import { Select } from "@mantine/core";
import classnames from "classnames";
import { useCallback, useMemo } from "react";
import type { Meter, Site } from "../../../../../utils/backend-types";
import { getMeterDisplayName } from "../../../../../utils/meter";

interface EnergyMeterSelectProps {
  sites: Array<Site>;
  meters: Array<Meter>;
  onChangeMeter: (meterId: number | null) => void;
}

function EnergyMeterSelect({
  sites,
  meters,
  onChangeMeter
}: EnergyMeterSelectProps) {
  const options = useMemo(() => {
    const groups = Array.from(new Set(meters.map((meter) => meter.site)));
    const filledGroups = groups.map((siteId) => {
      const site = sites.find((s) => s.id === siteId);
      const groupName = site ? site.name : "Unbekannte Liegenschaft";
      const items = meters
        .filter((meter) => meter.site === siteId)
        .map((meter) => ({
          label: getMeterDisplayName(meter),
          value: meter.id.toString()
        }));
      return {
        group: groupName,
        items
      };
    });
    return filledGroups;
  }, [meters, sites]);

  const handleMeterSelectChange = useCallback(
    (value: string | null) => {
      if (value === null) {
        onChangeMeter(null);
      } else {
        onChangeMeter(parseInt(value, 10));
      }
    },
    [onChangeMeter]
  );

  return (
    <div className={classnames("meter-dropdown")}>
      <Select
        data={options}
        id="meter-number-select-id"
        name="meter-number-select-class"
        placeholder="Zähler auswählen"
        required
        onChange={handleMeterSelectChange}
      />
    </div>
  );
}

export { EnergyMeterSelect };
